import { Injector, Component, OnInit, Inject } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { DOCUMENT } from '@angular/common';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';
import { ToggleOptions } from '@metronic/app/core/_base/layout/directives/toggle.directive';
import { Router } from '@angular/router';

@Component({
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  selector: 'default-layout',
  animations: [appModuleAnimation()],
})
export class DefaultLayoutComponent
  extends ThemesLayoutBaseComponent
  implements OnInit {
  menuCanvasOptions: OffcanvasOptions = {
    baseClass: 'aside',
    overlay: true,
    closeBy: 'kt_aside_close_btn',
    toggleBy: 'kt_aside_mobile_toggle',
  };

  userMenuToggleOptions: ToggleOptions = {
    target: this.document.body,
    targetState: 'topbar-mobile-on',
    toggleState: 'active',
  };

  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

  constructor(
    injector: Injector,
    private router:Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(injector);
  }

  isMobileDeviceActive = false;
  
  ngOnInit() {
    this.installationMode = UrlHelper.isInstallUrl(location.href);
    this.isMobileDeviceActive = KTUtil.isMobileDevice();    
  }
  
  isMinimized(){
    return document.body.classList.contains('aside-minimize')
  }
  navigateToFeedback(){
    window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=MhPQG8-o90SmMjMuybOM3ebnL2Y_G7tOnb8OklOYNSpUNjBKUjI3ODVERFpCRzJTUVRLNkE4RjMwTi4u","_blank")
  }

  navigateToHelp(){
    console.log(this.userMenuToggleOptions,this.isMobileDeviceActive)
    window.open("https://heyallo.co/FAQ", "_blank")
  }
}
